export default "__VITE_ASSET__CHj3yZXh__"